import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LocalStorageService, SessionStorageService } from 'angular-web-storage';
import { CredentialsService } from 'src/app/authentication/credentials.service';
import { UserRoles } from '../../models/user.interface'
import { vovSharedService } from '../../services/vov-shared.service';
import { Subject } from 'rxjs';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  [x: string]: any;
  @Input() headerName: string;
  @Input() isWavier: boolean;
  public isLogOut: boolean = false;
  public hideMe: boolean = false;
  public userRoles = [];
  public isAdminUrl;
  public showAdmin;
  public iscodeEnforcement: boolean = false;
  public onUserSessionExpire = new Subject<any>();
  constructor(
    private activeRouter: ActivatedRoute,
    private router: Router,
    // private localStorage: LocalStorageService,
    // private sessionStorage: SessionStorageService,
    private vovSharedService: vovSharedService,
    private credentials: CredentialsService
  ) { }

  ngOnInit(): void {
    if (this.router.url.split(';')[0] == '/forgot-pwd') {
      this.hideMe = false;
      this.iscodeEnforcement = true;
      this.isLogOut = true;

    }
    if (this.router.url.split(';')[0] == '/officer' || this.router.url.split(';')[0] == '/staff' || this.router.url.split(';')[0] == '/admin') {
      this.isLogOut = true;
    }
    if (this.router.url == '/enforcement' || this.router.url == '/search-address') {
      this.isLogOut = true;
      // this.iscodeEnforcement = true;
      console.log(this.router.url);
      const user = this.credentials.getUser();
      const isAdmin = user.userRoles.some(role => role.roleId == UserRoles.ADMIN)
      if (isAdmin) {
        this.userRoles = user.userRoles.filter(role => role.roleId == UserRoles.ADMIN);
      } else {
        this.userRoles = user.userRoles.filter(role => role.roleId != UserRoles.ADMIN);
      }
      console.log(this.userRoles);
    }

    if (this.router.url.split(';')[0] == '/login') {
      this.hideMe = true;
      this.iscodeEnforcement = true;

    }

    if (this.router.url == '/create-case' || this.router.url == '/expired-case' || this.router.url == '/case-listing') {
      // this.isLogOut = false;
      this.iscodeEnforcement = true;
    }
    let currentUser = this.credentials.getUser();
    let isroleAdmin = currentUser ? currentUser.userRoles.some(user => user.role.name == 'Admin') : '';
    console.log(isroleAdmin, 'adminnnn')

    if (this.router.url.split(';')[0] == '/admin') {
      this.isAdminUrl = true;
    }

    if (isroleAdmin && (this.router.url.split(';')[0] == '/officer' || this.router.url.split(';')[0] == '/staff')) {
      this.showAdmin = true;
    }
    // this.listenSubjects();
  }

  // private async listenSubjects() {
  //   this.vovSharedService.onUserSessionExpire.subscribe(() => {
  //     this.logout();
  //   });

  // }

  goOfficerUrl() {
    this.router.navigate(['/officer'], { replaceUrl: true })
  }

  goStaffUrl() {
    this.router.navigate(['/staff'], { replaceUrl: true })

  }

  goAdminUrl() {
    this.router.navigate(['/admin'], { replaceUrl: true })
  }

  // navigation links
  gotoOfficer() {
    this.router.navigate(['/sign-in', { isOfficer: UserRoles.OFFICER }], { replaceUrl: true })
  }
  gotoAdmin() {
    this.router.navigate(['/sign-in', { isAdmin: UserRoles.ADMIN }], { replaceUrl: true })
  }
  gotoVillageStaff() {
    const isVillageStaff = true;
    this.router.navigate(['/sign-in', { isVillageStaff: UserRoles.STAFF }], { replaceUrl: true });
  }

  gotoLogOut() {
    console.log('hjdhjd')
    const user = this.credentials.getUser();
    // this.router.navigate(['/sign-in'], { replaceUrl: true });
    if (user) {
      if (this.router.url == '/enforcement' || this.router.url == '/search-address' || this.router.url == '/create-case' || this.router.url == '/expired-case' || this.router.url == '/case-listing') {
        sessionStorage.removeItem('currentUser');
        localStorage.removeItem('currentUser');
        this.router.navigate(['/code-sign-in'], { replaceUrl: true });
      } else {
        sessionStorage.removeItem('currentUser');
        localStorage.removeItem('currentUser');
        this.router.navigate(['/sign-in'], { replaceUrl: true });
      }

    } else {
      if (this.router.url == '/enforcement' || this.router.url == '/search-address' || this.router.url == '/create-case' || this.router.url == '/expired-case' || this.router.url == '/case-listing') {
        sessionStorage.removeItem('currentUser');
        localStorage.removeItem('currentUser');
        this.router.navigate(['/code-sign-in'], { replaceUrl: true });
      } else {
        sessionStorage.removeItem('currentUser');
        localStorage.removeItem('currentUser');
        this.router.navigate(['/sign-in'], { replaceUrl: true });
      }
    }
    //else{
    //   this.router.navigate(['/create-waiver'], { replaceUrl: true });
    // }
  }

  goHome() {
    const user = this.credentials.getUser();
    if (user) {
      if (this.router.url == '/enforcement' || this.router.url == '/create-case' || this.router.url == '/expired-case' || this.router.url == '/case-listing') {
        this.router.navigate(['/enforcement'], { replaceUrl: true });
      } else if (this.router.url.split(';')[0] == '/login') {
        sessionStorage.removeItem('currentUser');
        localStorage.removeItem('currentUser');
        this.router.navigate(['/sign-in'], { replaceUrl: true });
      }
    } else {
      if (this.router.url.split(';')[0] == '/login' || this.router.url.split(';')[0] == '/officer' || this.router.url.split(';')[0] == '/staff' || this.router.url.split(';')[0] == '/admin' || this.router.url.split(';')[0] == '/forgot-pwd') {
        this.router.navigate(['/sign-in'], { replaceUrl: true });
      } else {
        this.router.navigate(['/create-waiver']);
      }
    }
    // if(user){

    //   this.router.navigate(['/sign-in'], { replaceUrl: true });
    //   sessionStorage.removeItem('currentUser');
    //   localStorage.removeItem('currentUser');
    //  }else{
    //   this.router.navigate(['/create-waiver']);
    //   // sessionStorage.removeItem('currentUser');
    //   // localStorage.removeItem('currentUser');
    //  }

  }

  gotoHome() {
    // window.location.reload();
    this.router.navigate(['/sign-in']);

  }

  getHomeUrl(currentLogin?) {
    const userData = this.getUser();
    let role;
    const navigateUrl = JSON.stringify(currentLogin).replace(/[{}']/g, "").replace(':', '=').replace(/["']/g, "");
    if (!userData) {
      return 'login/navigateUrl';
    }
    if (userData) {
      const officerRole = JSON.parse(userData).userRoles.filter(u => u.roleId == UserRoles.OFFICER);
      const staffRole = JSON.parse(userData).userRoles.filter(u => u.roleId == UserRoles.STAFF);
      const adminRole = JSON.parse(userData).userRoles.filter(u => u.roleId == UserRoles.ADMIN);
      const superAdminRole = JSON.parse(userData).userRoles.filter(u => u.roleId == UserRoles.SUPER_ADMIN);
      console.log(currentLogin, 'currentLogin', adminRole)
      // const user_role = JSON.parse(userData).userRoles? JSON.parse(userData).userRoles[0].role.name : null;
      const user_role = 'Admin';
      // adminRole.length !== 0 && adminRole[0].role.name == 'Admin' &&
      if (user_role == null) {
        return '/admin';
      }
      if (user_role != 'Admin') {
        // return '/admin';
      } else if ((officerRole.length !== 0 && officerRole[0].role.name == 'Officer' || adminRole.length !== 0 && adminRole[0].role.name == 'Admin') && currentLogin.isOfficer) {
        return '/officer';
      } else if ((staffRole.length !== 0 && staffRole[0].role.name == 'Staff' || adminRole.length !== 0 && adminRole[0].role.name == 'Admin') && currentLogin.isVillageStaff) {
        return '/staff';
      } else if ((officerRole.length !== 0 && officerRole[0].role.name == 'Officer' || adminRole.length !== 0 && adminRole[0].role.name == 'Admin') && currentLogin.isAdmin) {
        return '/admin';
      }
      // else if (currentLogin.isAdmin) {
      //   return '/admin';
      // }
      else if (superAdminRole.length !== 0 && superAdminRole[0].role.name == 'Super_Admin' && currentLogin.isAdmin) {
        return '/admin';
      } else {
        return '/sign-in';
      }
    }
  }

}
